import { AdminService } from '../../../../services/admin.service'
import { toastActions } from './../../../../actions/toast.actions'
import { updateClientConstants } from './update-client.constants'
import { Creators as SiteCreators } from '../../../../ducks/site/site'

/**
 * Updates client info
 * @param {string} clientId
 * User identity id
 */
const getClientById = (clientId) => async (dispatch) => {
	dispatch(SiteCreators.showLoading())
	dispatch({
		type: updateClientConstants.GET_CLIENT,
	})
	AdminService.getClientById(clientId).then((data) => {
		dispatch(SiteCreators.hideLoading())
		if (data) {
			dispatch({
				type: updateClientConstants.SET_CLIENT,
				payload: data,
			})
		}
	})
}

/**
 * Updates client info
 * @param {string} clientId
 * User identity id
 */
const updateClient = (client) => async (dispatch) => {
	dispatch({
		type: updateClientConstants.UPDATE_CLIENT,
	})

	dispatch(SiteCreators.showLoading())
	AdminService.updateClient(client).then(({ errors }) =>
		dispatch(clientUpdated(errors))
	)
}

/**
 * Called when client's update is done'
 * @param {string} clientId
 * errors - may containt errors
 */
const clientUpdated = (errors) => (dispatch) => {
	dispatch({
		type: updateClientConstants.CLIENT_UPDATED,
		errors,
	})
	dispatch(SiteCreators.hideLoading())
	const { danger, success } = toastActions
	let toastAction = null
	if (errors) {
		if (errors.length) {
			toastAction = danger({ message: errors[0] })
		} else {
			toastAction = danger(
				'Não foi possível atualizar os dados. Tente novamente mais tarde.'
			)
		}
	} else {
		toastAction = success({
			message: 'Cadastro do cliente atualizado com sucesso',
		})
	}
	dispatch(toastAction)
}

/**
 * Called to set the billing address
 * @param {integer} addresses index of the billing address in the array
 */
const updateAddresses = (clientId) => async (dispatch) => {
	AdminService.getClientById(clientId).then(({ addresses }) =>
		dispatch({
			type: updateClientConstants.UPDATE_ADDRESSES,
			payload: addresses,
		})
	)
}

export const updateClientActions = {
	getClientById,
	updateClient,
	clientUpdated,
	updateAddresses,
}
